/**
 * Build yyyy-Qx quarter options from currentYear - 3 through currentYear + 1.
 * @returns {string[]} Quarter strings in yyyy-Qx format
 */
export function getQuarterOptions() {
  const currentYear = new Date().getFullYear();
  const quarters = [];
  for (let year = currentYear - 3; year <= currentYear + 1; year++) {
    for (let q = 1; q <= 4; q++) {
      quarters.push(`${year}-Q${q}`);
    }
  }
  return quarters;
}
